import React, { Component } from 'react';

import axios from 'axios';

import Autosuggest from 'react-autosuggest';
import Modal from 'react-modal';

import DynamicLabelInput from './DynamicLabelInput';

import '../assets/ftyc/css/custom-autosuggest-mobile-friendly.css';

import '../assets/ftyc/css/custom-autosuggest.css';

  
  // When suggestion is clicked, Autosuggest needs to populate the input
  // based on the clicked suggestion. Teach Autosuggest how to calculate the
  // input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion.name;
  
  // Use your imagination to render suggestions.
const renderSuggestion = suggestion => <div className={'custom-autosuggest-suggestion'}>{suggestion.name}</div>;


const renderSuggestionsContainer = ({ containerProps , children, query }) => {
    return (
      <div {...containerProps} className={'custom-autosuggest-container'}>
        {children}
      </div>
    );
}

const modalStyle = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#fff',
      fontFamily: '"Open Sans", sans-serif'
    },
    content: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      border: 0,
      padding: 0,
      overflow: 'hidden',
      outline: 'none',
      height: '100%'
    }
};

class CustomAutosuggestMobileFriendly extends Component{

    constructor(props){
        super(props);
        this.state = {
            cities: [],
            value: {
                name: '',
                id: null
            },
            isModalOpen: false
        }
        this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
        this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
        this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
        this.cleanValueIfNotSelected = this.cleanValueIfNotSelected.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onChange = this.onChange.bind(this);
        this.getCities = this.getCities.bind(this);
    }

    onSuggestionsFetchRequested = (rs) => {
        if(rs.value.length < 1 || this.state.value.id){
            this.setState({
                cities: []
            })
        }else{
            this.getCities(rs.value)
        } 
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    onSuggestionsClearRequested = () => {
        this.setState({
        cities: []
        });
    };

    onSuggestionSelected = (event, item) => {

        this.setState({
            value: item.suggestion,
            cities: []
        });

        if (this.props.onChange) {
            this.props.onChange(item.suggestion);
        }

        this.props.input.onChange(item.suggestion.name);

        this.closeModal()
    }

    cleanValueIfNotSelected = () => {
        let {value} = this.state
        if(!value.id){
            this.setState({value: {
                name: '',
                id: null
            }})
        }
    }

    openModal = () => {
        this.setState({
            isModalOpen: true,
            cities: []
        });
    };

    closeModal = () => {
        this.setState({
            isModalOpen: false
        });
    };

    onChange = (event, value) => {
        this.setState({
            value: {
                id: null,
                name: value.newValue
            }
        })

        if(this.state.value.id){
            this.props.input.onChange(null)
        }
    };

    getCities(query) {

        const { selectedState } = this.props

        const ROOT_URL = process.env.API_URL;
        const config = {
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };
        axios.get(`${ROOT_URL}/states/${selectedState}/cities/_search/${query}`, config).then((response)=> {
            response.data.cities.map((element)=> {
                element.name = element.name.split(" ").map((palabra) => {
                        return palabra[0].toUpperCase() + palabra.substring(1);
                }).join(" ");
            });
            this.setState({
                cities: response.data.cities
            });
        });
    }


    render(){
        const { cities, isModalOpen } = this.state
        return (
            <div>
                <DynamicLabelInput
                    name="locality"
                    className="form-control"
                    showLabel={['ftyc', 'fiduciaria', 'cuyoaval', 'cuyoavalcheque'].includes(process.env.PAGE)}
                    placeholder="Localidad"
                    type={'text'}
                    autoComplete={'asd'}
                    value={this.props.input.value}
                    onClick={this.openModal}
                    onChange={(value)=>{}}/>
                <Modal
                    isOpen={isModalOpen}
                    contentLabel="Modal"
                    onRequestClose={this.closeModal}
                    shouldCloseOnOverlayClick={false}
                    closeTimeoutMS={
                        1 /* otherwise the modal is not closed when suggestion is selected by pressing Enter */
                    }
                    style={modalStyle}
                    >
                    <div className={'modal-autosuggest-title'}>Por favor escribe una localidad:</div>
                    <div className={'modal-autosuggest-container'}>
                        <Autosuggest
                            suggestions={cities}
                            alwaysRenderSuggestions={true}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                            onSuggestionSelected={this.onSuggestionSelected} 
                            getSuggestionValue={getSuggestionValue}
                            renderSuggestion={renderSuggestion}
                            renderSuggestionsContainer={renderSuggestionsContainer}
                            inputProps={{ 
                                autoComplete: 'asd',
                                className:'form-control',
                                value: this.state.value.name,
                                onChange: this.onChange,
                                onBlur: this.cleanValueIfNotSelected,
                                autoFocus: true
                            }}
                        />
                    </div>
                    <button className={'modal-cancel-button'} onClick={this.closeModal}>
                        Cancelar
                    </button>
                </Modal>
            </div>
        );
    }
}

export default CustomAutosuggestMobileFriendly;


/** WEBPACK FOOTER **
 ** ./src/components/CustomAutosuggestMobileFriendly.js
 **/